import mod from "-!./TheAccount.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./TheAccount.js?vue&type=script&lang=js&external"